export const ClientDetailsFromAI = (json: IClientDetailsFromAI): IClientDetailsFromAIModel => {
	const {
		email,
		first_name,
		last_name,
		city,
		gender,
		birth_date,
		diet_expectation,
		lifestyle,
		weight,
		weight_goal,
		height,
		onboarding_completed,
		onboarding_completion_percentage,
		favorite_ingredients,
		disliked_ingredients,
		favorite_dishes,
		disliked_dishes,
		allergens,
		favorite_cuisines,
		disliked_cuisines,
		preferred_price_per_day,
		flavor_profile,
		active_diets,
		...rest
	} = json

	return {
		email,
		firstName: first_name,
		lastName: last_name,
		city,
		gender,
		birthDate: birth_date,
		dietExpectation: diet_expectation,
		lifestyle,
		weight,
		weightGoal: weight_goal,
		height,
		onboardingCompleted: onboarding_completed,
		onboardingCompletionPercentage: onboarding_completion_percentage,
		favoriteIngredients: favorite_ingredients ?? [],
		dislikedIngredients: disliked_ingredients ?? [],
		favoriteDishes: favorite_dishes ?? [],
		dislikedDishes: disliked_dishes ?? [],
		allergens: allergens ?? [],
		favoriteCuisines: favorite_cuisines ?? [],
		dislikedCuisines: disliked_cuisines ?? [],
		preferredPricePerDay: preferred_price_per_day,
		flavorProfile: flavor_profile,
		activeDiets: active_diets,
		...rest,
	}
}
